<div class="row">
    <div div class="col-sm-12 col-xl-12 xl-100">
      <ngb-carousel *ngIf="banners" [showNavigationArrows]="true" [showNavigationIndicators]="false">
        <ng-template ngbSlide *ngFor="let image of banners">
          <!-- SC Original<div class="picsum-img-wrapper"  [ngStyle]="{'background-image': 'linear-gradient(rgba(107, 161, 106, 0.45), rgb(131, 200, 129))'}"> -->
          <div class="picsum-img-wrapper">
            
            <img [src]="image.name" alt="Random slide" class="img-fluid" >
          </div>
          <div class="carousel-caption d-none d-md-block">
            <!-- SC CAT-130 Se modifica agregar titulo con h1. y se agrega clse flex-banner-->
            <h1 class="flex-banner">{{image.tittle}}</h1>
            <p class="flex-banner">{{image.description}}</p>
          </div>
        </ng-template>
      </ngb-carousel>
  </div>
  </div>
  <br />
